// extracted by mini-css-extract-plugin
export default {"completedChallengesContainer":"CompletedChallenges_completedChallengesContainer__E+lYh"};